import React, { FC } from 'react';

type Props = {
  onWishlist: boolean;
  className?: string;
  pathClassName?: string;
  fill?: string;
  onClick?: () => void;
};

const Icon: FC<Props> = ({ onWishlist, className, onClick, pathClassName = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      data-testid="heart-icon"
      className={`${onWishlist ? 'rounded-full border-2 border-gray-300' : ''} ${className}`}
      onClick={onClick}
    >
      <rect width="18" height="18" rx="9" fill={`${onWishlist ? '#ffffff' : '#1f1f1f1a'}`} />
      <path
        d="M4.92969 10.0359L8.45898 13.4072C8.60547 13.5471 8.79883 13.625 9 13.625C9.20117 13.625 9.39453 13.5471 9.54102 13.4072L13.0703 10.0359C13.6641 9.47032 14 8.67695 14 7.84761V7.7317C14 6.33482 13.0137 5.14377 11.668 4.91395C10.7773 4.76207 9.87109 5.05983 9.23438 5.71131L9 5.95112L8.76562 5.71131C8.12891 5.05983 7.22266 4.76207 6.33203 4.91395C4.98633 5.14377 4 6.33482 4 7.7317V7.84761C4 8.67695 4.33594 9.47032 4.92969 10.0359Z"
        fill={`${onWishlist ? 'var(--saf-color-orange-500)' : '#ffffff'}`}
        className={pathClassName}
      />
    </svg>
  );
};

export default Icon;
